import {
  emptyString,
  globalConstants,
  themeSettingsConstants,
} from "../../constants";

const { SUCCESS } = globalConstants;
const { UPDATE_THEME, EXISTING_THEME, RESET_THEME, DELETE_LOGO } =
  themeSettingsConstants;

//Default reducer
const initialState = {
  theme: {},
  existingTheme: {},
  deletedBrandId: emptyString,
};

//Exporting theme settings reducer
export const themeSettingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_THEME + SUCCESS:
      return { ...state, theme: action.data };
    case EXISTING_THEME + SUCCESS:
      return { ...state, existingTheme: action.data };
    case RESET_THEME + SUCCESS:
      return { ...state, existingTheme: action.data };
    case DELETE_LOGO + SUCCESS:
      return {
        ...state,
        existingTheme: { ...state.existingTheme, logo: emptyString },
        deletedBrandId: action.data,
      };
    default:
      return state;
  }
};
